import { gql, useQuery } from '@apollo/client';
import {
  GetArticleHistoryCountQuery,
  GetArticleHistoryCountQueryVariables,
} from '../../__generated__/queries-web';

const GET_ARTICLE_HISTORY_COUNT = gql`
  query GetArticleHistoryCount($where: ArticleHistoryFilterInput) {
    articleHistoryCount(where: $where)
  }
`;

export const useGetArticleHistoryCount = (id: string) =>
  useQuery<GetArticleHistoryCountQuery, GetArticleHistoryCountQueryVariables>(
    GET_ARTICLE_HISTORY_COUNT,
    {
      variables: { where: { article: { id } } },
      skip: !id,
      fetchPolicy: 'network-only',
    },
  );
